import { useIsClient } from "usehooks-ts";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "./Toast";
import { useToast } from "./useToast";
import { type ToastHaptics, useToastHaptics } from "./useToastHaptics";

import { titleAndDescription, actions } from "./Toast.module.scss";

type ToasterProps = {
  // Toaster owns the mapping from variant to haptic type; the app supplies
  // the actual bridge call, which is the only part this library can't own.
  haptics?: ToastHaptics;
};

const Toaster = ({ haptics }: ToasterProps) => {
  const { toasts, isLowPriority } = useToast();
  const isClient = useIsClient();

  useToastHaptics(haptics);

  if (!isClient) return null;

  return (
    <ToastProvider duration={5000}>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className={titleAndDescription}>
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            <div className={actions}>
              {action}
              <ToastClose />
            </div>
          </Toast>
        );
      })}
      <ToastViewport
        id={`toaster-viewport`}
        data-priority={isLowPriority ? "low" : undefined}
      />
    </ToastProvider>
  );
};

export { Toaster };
export type { ToasterProps };
